import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import style from '../admin/exam/ExamResult.module.css'
import axios from 'axios'
import { baseUrl } from '../../baseUrl'

const ReviewExam = () => {
  const params = useParams()
  const [review, setReview] = useState([])
  const [loading,setLoading]=useState(false)
  const getQuestionNumber = (subject,index) => {
    const sectionRanges = {
      "Physics": { start: 1, end: 45 },
      "Chemistry": { start: 46, end: 90 },
      "Biology": { start: 91, end: 180 },
    };
  
    const sectionKey = `${subject}`;
    const sectionRange = sectionRanges[sectionKey];
  
    if (sectionRange) {
      return sectionRange.start + index; // Adds the index to the start of the section's range
    }
  
    return null; // If section is not found
  };
  useEffect(() => {
    setLoading(true)
    axios.get(`${baseUrl}/student/exam/review?email=${params.email}&examId=${params.examId}`)
      .then(res => {setReview(res.data);setLoading(false)})
      .catch(err => {console.log(err);setLoading(false)})
  }, [])
  const filterAndMapQuestions = (subject) => {
    const filteredQuestions = review?.answers?.filter(q => q.subject === subject);
    return filteredQuestions;
  };

  return (
    <div className='mb-3'>
      <h2 className='text-center mt-2 mb-2'>Exam Review</h2>
      {
        loading?
        <div className='container d-flex justify-content-center'>
          <img src="/assets/images/load-time.gif" width='50px' alt="loading"/>
        </div>
        :
        <div className={`${style.instruction} container-lg`}>
        <h4 className='text-center'>Physics</h4>
        {
          filterAndMapQuestions('Physics') &&
          filterAndMapQuestions('Physics').map((q, i) =>
            <div className=' p-2 m-2'>
              <div className="mb-2"
                dangerouslySetInnerHTML={{
                  __html: `<span class='mr-2 fw-bold fs-6'>${getQuestionNumber(q.subject, i)}.</span></&nbsp;&nbsp;<span>${q.question}</span>`,
                }}
              >
              </div> 
              <div
                className={`mb-2 d-flex ${q.attempted ? (q.isCorrect ? 'text-success' : 'text-danger') : 'text-info'}`}
                dangerouslySetInnerHTML={{
                  __html: `
                    <span>Your answer:</span>&nbsp;&nbsp;
                    <span>${q.answer ? q.answer : 'N/A'}</span>
                    `,
                }}
              ></div>
              <div className="mb-2 d-flex"
                dangerouslySetInnerHTML={{
                  __html: `<span>Correct answer:</span>&nbsp;&nbsp;<span>${q.options[q.correctAnswer-1]}</span>`,
                }}
              >
              </div>
            </div>
          )
        }
        <h4 style={{borderTop:"1px solid black"}} className='pt-2 text-center'>Chemistry</h4>
        {
          filterAndMapQuestions('Chemistry') &&
          filterAndMapQuestions('Chemistry').map((q, i) =>
            <div className=' p-2 m-2'>
              <div className="mb-2"
                dangerouslySetInnerHTML={{
                  __html: `<span class='mr-2 fw-bold fs-6'>${getQuestionNumber(q.subject, i)}.</span></&nbsp;&nbsp;<span>${q.question}</span>`,
                }}
              >
              </div> 
              <div
                className={`mb-2 d-flex ${q.attempted ? (q.isCorrect ? 'text-success' : 'text-danger') : 'text-info'}`}
                dangerouslySetInnerHTML={{
                  __html: `
                    <span>Your answer:</span>&nbsp;&nbsp;
                    <span>${q.answer ? q.answer : 'N/A'}</span>
                    `,
                }}
              ></div>
              <div className="mb-2 d-flex"
                dangerouslySetInnerHTML={{
                  __html: `<span>Correct answer:</span>&nbsp;&nbsp;<span>${q.options[q.correctAnswer-1]}</span>`,
                }}
              >
              </div>
            </div>
          )
        }
                <h4 style={{borderTop:"1px solid black"}} className='pt-2 text-center'>Biology</h4>
        {
          filterAndMapQuestions('Biology') &&
          filterAndMapQuestions('Biology').map((q, i) =>
            <div className=' p-2 m-2'>
              <div className="mb-2"
                dangerouslySetInnerHTML={{
                  __html: `<span class='mr-2 fw-bold fs-6'>${getQuestionNumber(q.subject, i)}.</span></&nbsp;&nbsp;<span>${q.question}</span>`,
                }}
              >
              </div> 
              <div
                className={`mb-2 d-flex ${q.attempted ? (q.isCorrect ? 'text-success' : 'text-danger') : 'text-info'}`}
                dangerouslySetInnerHTML={{
                  __html: `
                    <span>Your answer:</span>&nbsp;&nbsp;
                    <span>${q.answer ? q.answer : 'N/A'}</span>
                    `,
                }}
              ></div>
              <div className="mb-2 d-flex"
                dangerouslySetInnerHTML={{
                  __html: `<span>Correct answer:</span>&nbsp;&nbsp;<span>${q.options[q.correctAnswer-1]}</span>`,
                }}
              >
              </div>
            </div>
          )
        }
      </div>
      }
    </div>
  )
}

export default ReviewExam
